export default __webpack_public_path__ + "static/media/key-enter.b0ed37b6.svg";